module.exports = __webpack_public_path__ + "img/20190928142721360截图20190928132314600.033f0299.jpg";